import { API } from '@/api/config'
// import { ObjectToQueryString } from '@/_helper';

export default new class FilledForm {

  updateResultStatus(data){
    return API.ACCOUNTS.patch(`/filled-form/${data.filledFormId}`, data)
  }

}